/**
 * Copyright (c) 2021-present Alibaba Cloud, Inc
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { useEffect, useRef, useState, memo } from 'react';
import IFrame from './IFrame';
import appCenter from '@alife/superapp-app-center';

const AppContainer: React.FC<any> = (props) => {
  const container = useRef<any>(null);
  const [mounted, setMounted] = useState<boolean>(false);
  const [appConfig, setAppConfig] = useState<any>({
    name: '',
    scripts: [],
    styles: [],
  });
  const initMicroApp = () => {
    const { name, scripts, styles, ...otherProps } =
    window.microApps?.find(
      (item) =>
        item.path?.replace('#', '') === window.location.hash.replace('#', '') ||
        item.name === props?.name,
    ) || {};
    if (!name) {
      throw new Error('SUPERAPP_AppContainer_404');
    }
    setAppConfig({ name, scripts, styles, ...otherProps });
  }
  const unloadMicroApp = () => {
    const name = appConfig.name;
    if (!name) return;
    try {
      appCenter.unmount(name);
      // delete appCenter._loaded[name];
     //  delete appCenter._apps[name];
      if (container.current.firstElementChild) {
        container.current.firstElementChild.remove();
      }
    } catch (err) {
      console.log('unmounted error:', err.message);
    }
  }
  useEffect(() => {
    initMicroApp();
    const { name, scripts, styles, ...otherProps } =
      (window.microApps || []).find(
        (item) =>
          item.path?.replace('#', '') === window.location.hash.replace('#', '') ||
          item.name === props?.name,
      ) || {};
    if (name) setAppConfig({ name, scripts, styles, ...otherProps });
    else
      throw new Error(
        $i18n.get({
          id: 'aopf.components.AppContainer.ChineseSuperappAppcontainer',
          dm: 'SUPERAPP_AppContainer_404',
        }),
      );

    return () => {
      unloadMicroApp();
    }
  }, []);
  useEffect(() => {
    setMounted(false);
    // unloadMicroApp();
    initMicroApp();
  }, [props.name]);
  useEffect(() => {
    const containerEle = container.current;

    const config = { attributes: true, childList: true, subtree: true };

    const callback = function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
        } else if (mutation.type === 'attributes') {
          setMounted(true);
        }
      }
    };

    const observer = new MutationObserver(callback);

    if (containerEle) {
      observer.observe(containerEle, config);
    }

    return () => {
      if (containerEle) {
        observer.disconnect();
      }
    };
  }, [container.current]);
  useEffect(() => {
    if (!appConfig.name) return;
    const mounted = appCenter.mounted(appConfig.name);
    !mounted && appCenter.load(appConfig.name, appConfig.scripts, appConfig.styles);
    if (!container.current) return;
    let div;
    if (!mounted) {
      div = document.createElement('div');
      container.current.appendChild(div);
    } else {
      div = container.current.firstElementChild;
      if (!div) {
        div = document.createElement('div');
        container.current.appendChild(div);
      }
    }
    // Execute render application
    appCenter.mount(appConfig.name, div);
    return () => {
      unloadMicroApp();
    }
  }, [appConfig.name]);
  const Loading: any = props.loading;
  const loadingStyle = !mounted
    ? {
        position: 'absolute',
        left: '50%',
        width: '200px',
        height: '200px',
        top: '20%',
      }
    : {};
  return appConfig.iframe ? (
    <IFrame {...appConfig} />
  ) : (
    <>
      <Loading style={loadingStyle} visible={!mounted}></Loading>
      <div id={appCenter.appContainerId} ref={container}></div>
    </>
  );
};

export default memo(AppContainer);
